export default __webpack_public_path__ + "982dec23e59689f07242e33bbadaeb16.png";